import { Button, Grid } from "@material-ui/core"
import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { traerPreafiliadoExternoPorCuil } from "../../actions/autogestion/preafiliadoAutogestion"
import { fetchCategoriasAutogestion } from "../../actions/cbos/categorias"

import {  useParams } from 'react-router-dom'
import { PanelDatosAutogestion } from "./PanelDatosAutogestion"
import { Alert } from "./Alert"
import aviso from '../../assets/icono-vencido.png';

export const Step1= () => {
    const {afiliadoEncontrado} = useSelector(state => state.preinscripto)
    const {usuarioAutogestion} = useSelector(state => state.userAutogestion)
    const {cuil} = useParams();
    const dispatch = useDispatch();
    

    useEffect(() => {
        if(Object.keys(usuarioAutogestion).length!==0){
            dispatch(fetchCategoriasAutogestion());
            dispatch(traerPreafiliadoExternoPorCuil(cuil));   
        }
        // eslint-disable-next-line
    }, [usuarioAutogestion])

    const send = () => {
        document.querySelector(`#btnsubmit1`).click();
    }
    return(
        <>  
            {afiliadoEncontrado!==null&&<Alert 
            ico={aviso}
            />}
            <Grid container justify="center" direction="row">
                {afiliadoEncontrado!==null&&
                (afiliadoEncontrado?.estado===0 || afiliadoEncontrado?.estado ===1)&&
                <Grid style={{background:'white',padding:10,borderRadius:10,margin:40}} item lg={9}  >
                    <PanelDatosAutogestion idPanel="idTabIngreso" id="autoGestion"/>
                    <Grid container justify="center" >
                        <Button variant="contained" color="primary" disableElevation style={{width:'30%',margin:10}} onClick={send}>
                            ENVIAR
                        </Button>
                    </Grid>
                </Grid>
                }
            </Grid> 
        </>
    )
}